import { takeEvery, call, put, all } from "redux-saga/effects";
import { actionTypes, actions } from "./actions";
import { actions as commonActions } from "../../../../store/actions";
import {
  selloutApproveOrRejectFileApi,
  selloutFilterFileApprovals,
  fetchSelloutPendingApprovalAPi,
} from "../../../../api/endpoint";

function* getPendingApprovalSaga(action) {
  try {
    const _api = yield call(fetchSelloutPendingApprovalAPi, action.payload);
    yield put(actions.setFilesPendingApprovals(_api.data.results));
    yield put(commonActions.setLoading(false));
  } catch (error) {
    console.log(error);
    yield put(commonActions.setLoading(false));
  }
}

function* approveOrRejectFilesSaga(action) {
  try {
    const _api = yield call(selloutApproveOrRejectFileApi, action.payload);
    if (_api?.data?.success) {
      yield put(actions.setFilesPendingApprovals(null));
      // yield put(commonActions.setLoading(false));
    }
  } catch (error) {
    console.log(error);
  }
}

function* filterPendingApprovalsSaga(action) {
  try {
    const _api = yield call(selloutFilterFileApprovals, action.payload);
    if (_api?.data?.success) {
      yield put(actions.setFilesPendingApprovals(_api.data.results));
      yield put(commonActions.setClearFilter(true));
    }
  } catch (error) {
    console.log(error);
  }
}

export function* watchSelloutFileApprovalSaga() {
  yield all([
    takeEvery(actionTypes.SELLOUT_GET_FILE_PENDING_APPROVALS, getPendingApprovalSaga),
    takeEvery(actionTypes.SELLOUT_APPROVE_OR_REJECT_FILES, approveOrRejectFilesSaga),
    takeEvery(actionTypes.SELLOUT_GET_FILTERED_APPROVALS, filterPendingApprovalsSaga),
  ]);
}
